<template>
    <v-footer
            color="#2e7d32"
            padless

    >
        <v-layout
                justify-center
                wrap
        >
            <v-btn
                    v-for="link in links"
                    :key="link.id"
                    color="white"
                    text
                    rounded
                    class="my-2"
                    :to=link.ref
            >
                {{ link.title }}
            </v-btn>
            <v-flex
                    style="background-color: #92D050"
                    py-4
                    text-center
                    white--text
                    xs12
            >
                © {{ new Date().getFullYear() }} — <strong>STAG Legal</strong>
            </v-flex>
        </v-layout>
    </v-footer>
</template>

<script>
    export default {
        name: 'App',
        components: {
        },
        methods: {
        },
        data: () => ({
            links: [
                {
                    title: "Datenschutz",
                    ref: "/datenschutz"
                },
                {
                    title: "Impressum",
                    ref: "/impressum"
                }
            ]
        }),
    };
</script>
